import { render, staticRenderFns } from "./InstagramSendMessage.vue?vue&type=template&id=7f07ce44"
import script from "./InstagramSendMessage.vue?vue&type=script&lang=js"
export * from "./InstagramSendMessage.vue?vue&type=script&lang=js"
import style0 from "./InstagramSendMessage.vue?vue&type=style&index=0&id=7f07ce44&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports